<template>
  <step-section
    :title="$t('innerColorsTitle')"
    :loading="loading$"
    :step-number="getStepNumber('colorInner')"
  >
    <div class="row">
      <div class="col-12">
        <colors-group
          v-for="group in groups"
          v-bind="group"
          :key="group.id"
          :value="form.colorInner.id"
          @change="handleColorChange"
        />
      </div>
    </div>
  </step-section>
</template>

<script>
  import ColorsGroup from '@/components/ColorsGroup.vue';
  import stepMixin from './stepMixin';

  export default {
    name: 'ColorInnerStep',
    mixins: [stepMixin],
    props: {
      groups: Array,
    },
    methods: {
      handleColorChange(color) {
        this.updateFormField({
          field: 'colorInner',
          value: {
            id: color.id,
            name: color.name,
            photo: color.photo,
          },
        });
      },
    },
    components: {
      ColorsGroup,
    },
  };
</script>
